import { Customer } from '@/@types/customer';
import { Table } from '@/components/common';
import { ColumnDefinitionType } from '@/components/common/Table/table.utils';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';

export interface ICustomersTableProps {
  data: Customer[];
  columns: ColumnDefinitionType<Customer>[];
  sort?: 'desc' | 'asc';
  sortBy?: keyof Customer;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: object;
  pagination?: ITablePaginationProps;
}

export function CustomersTable({
  data,
  columns,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: ICustomersTableProps) {
  return (
    <Table
      data={data}
      columns={columns}
      additionalData={actions}
      sort={sort}
      sortBy={sortBy}
      onSort={onSort}
      pagination={pagination}
    />
  );
}
